export default "__VITE_ASSET__B4Kit2ET__"